import { Box, List, ListItem, makeStyles, Paper, Grid, Theme, Typography, useTheme } from '@material-ui/core';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTranslation } from 'react-i18next';

import ToastStr from '../../../request/toastStr';
import { member as v_member, basic, Values, member, SNACKBAR_TIME } from '../../../request/values';
import { TitleBackBar } from '../../../shared/header/TitleBar';
import { COLORS } from '../../../shared/Theme';
import { formatMoneyAmount, getTranslatedMaterialName } from '../../../locales/formatModule';

const useStyles = makeStyles((theme: Theme) => ({
	wrapper: {
		paddingTop: '10px',
		paddingLeft: '0',
		paddingRight: '0',
		[theme.breakpoints.up('md')]: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			paddingTop: '40px',
			paddingLeft: '20px',
			paddingRight: '20px',
			paddingBottom: theme.spacing(4),
		},
	},
	materialItem: {
		borderRadius: 12,
		margin: 'auto',
		marginBottom: '1.5vh',

		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		width: '98%',
		paddingTop: '2.2vh',
		paddingBottom: '2.2vh',
	},
	list: {
		width: '92%',
		height: '78vh',
		overflowY: 'auto',
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		...theme.typography.subtitle1,
		color: `${COLORS.BROWNISH_GREY}`,
		[theme.breakpoints.up('md')]: {
			...theme.typography.subtitle1,
			color: `${COLORS.BROWNISH_GREY}`,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			height: '100%',
		},
	},
	materialImage: {
		textAlign: 'center',
		margin: 'auto',
		'& img': {
			width: '11vw',
			maxWidth: '60px',
		},
	},
	materialDesc: {
		paddingLeft: '1vw',
		'& #materialName': {
			...theme.typography.subtitle2,
			color: `${COLORS.BROWNISH_GREY}`,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
		},
		'& #materialSubName': {
			...theme.typography.body2,
			color: `${COLORS.BROWNISH_GREY}`,
		},
	},
	orderComplete: {
		color: `${COLORS.WATER_BLUE}`,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
	},
	orderNone: {
		color: `${COLORS.DOWN}`,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
	},

	orderList: {
		width: '100%',
		maxWidth: 360,
	},
	orderSheet: {
		// height : 'calc(100%- 64px)',
		// top: 64
		height: '100vh',
	},
	paper: {
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		padding: theme.spacing(1),
		color: `${COLORS.BROWNISH_GREY}`,
	},
	grid: {
		width: '95%',
		marginTop: theme.spacing(1),
	},
	numberText: {
		...theme.typography.h2,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		[theme.breakpoints.up('lg')]: {
			...theme.typography.body2,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
		},
	},
}));

const MaterialOrderSheet: React.FC<any> = (props) => {
	const classes = useStyles();
	const history = useHistory();
	const theme = useTheme();
	const isLargeUp = useMediaQuery(theme.breakpoints.up('lg'));
	const { enqueueSnackbar } = useSnackbar();
	const { t } = useTranslation('student');

	const [materialSale, setMaterialSale] = useState([]);
	const [totalPrice, setTotalPrice] = useState(0);
	const { member } = props;

	const state: any = history.location.state;
	const order = state.order.materialOrderNum;
	const companyName = state.order.orderCompanyName;

	const getMaterialSaleSheetList = () => {
		console.log(totalPrice);
		let url = new URL(basic.server + v_member.member + v_member.material_order_sheet_list);
		let param = {
			materialOrderNum: order,
			classVersion: member.classVersion,
		};
		url.search = new URLSearchParams(param).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data) => {
				setTotalPrice(data.totalPrice.total_money);
				if (data.code === Values.SUCCESS_CODE) {
					if (data.materials === null) {
						enqueueSnackbar(ToastStr.MATERIAL_SHEET_LIST_EMPTY_STR, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else if (data.materials.length === 0) {
						enqueueSnackbar(ToastStr.MATERIAL_SHEET_LIST_EMPTY_STR, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						setMaterialSale((prevState) => data.materials);
					}
				} else if (data.code === Values.FAIL_CODE) {
					enqueueSnackbar(ToastStr.MATERIAL_SHEET_LIST_DUPLICATE_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				}
			});
	};

	useEffect(() => {
		getMaterialSaleSheetList();
	}, []);

	return (
		<div className="contentList" data-testid="dist-material-order-sheet-dashboard">
			<div className={classes.wrapper}>
				<TitleBackBar history={history} title={companyName} titleIcon="order" />
				{isLargeUp ? (
					<Grid container className={classes.grid} spacing={3}>
						{materialSale != null &&
							materialSale.map((item: any, index: number) => {
								return (
									<Grid item xs={6} key={index}>
										<Paper className={classes.paper}>
											<MaterialSaleItem {...item} />
										</Paper>
									</Grid>
								);
							})}
						{totalPrice === 0 ? (
							<div></div>
						) : (
							<Grid item xs={12}>
								<Paper className={classes.paper}>
									<Box textAlign="center">
										<Typography variant="subtitle1" data-testid={`dist-material-order-sheet-total-price`}>
											{t('MaterialOrderSheet.totalPrice')}: {formatMoneyAmount(totalPrice)}
										</Typography>
									</Box>
								</Paper>
							</Grid>
						)}
					</Grid>
				) : (
					<Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
						<List className={classes.list}>
							{materialSale != null &&
								materialSale.map((item: any, index: number) => {
									return (
										<ListItem className={classes.materialItem} alignItems="center">
											<MaterialSaleItem {...item} />
										</ListItem>
									);
								})}
							{totalPrice === 0 ? (
								<div></div>
							) : (
								<ListItem className={classes.materialItem} style={{ justifyContent: 'center' }} data-testid={`dist-material-order-sheet-total-price`}>
									{t('MaterialOrderSheet.totalPrice')}: {formatMoneyAmount(totalPrice)}
								</ListItem>
							)}
						</List>
					</Box>
				)}
			</div>
		</div>
	);
};

const MaterialSaleItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('student');
	const { t: tObject } = useTranslation('object');
	const materialName = getTranslatedMaterialName(tObject, props.materialCode.toString(), props.materialName);
	return (
		<Grid container alignContent="center">
			<Grid xs={2} className={classes.materialImage}>
				<img src={basic.server + '/displayImage?fileName=' + props.materialImage} />
			</Grid>
			<Grid xs={7} style={{ margin: 'auto' }}>
				<Grid container className={classes.materialDesc} direction="column">
					<Grid id="materialName">{materialName}</Grid>
					<Grid id="materialSubName">
						{props.materialSubName} {props.materialCode}
					</Grid>
				</Grid>
			</Grid>
			<Grid xs={2} style={{ margin: 'auto' }}>
				<div style={{ textAlign: 'end' }}>
					<Typography
						display="inline"
						className={classes.numberText}
						style={{
							color: `${COLORS.WATER_BLUE}`,
						}}
					>
						{formatMoneyAmount(props.materialPrice)}
					</Typography>
				</div>
				<div style={{ textAlign: 'end' }}>
					<Typography
						display="inline"
						className={classes.numberText}
						style={{
							color: `${COLORS.WATER_BLUE}`,
						}}
					>
						{`${props.materialCount} `}
					</Typography>
					<Typography
						display="inline"
						className={classes.numberText}
						style={{
							color: `${COLORS.BROWNISH_GREY}`,
						}}
					>
						{t('MaterialOrderSheet.unit')}
					</Typography>
				</div>
			</Grid>
		</Grid>
	);
};

export default MaterialOrderSheet;
